export const CONTRACT_VERSION = "v1.0";

export const LEGAL_LINKS = {
  contract: "/documents/legal/contratto-affidya-v1.pdf",
  privacy: "/legal/privacy",
  cookies: "/legal/cookies",
  terms: "/legal/terms",
};

export const LEGAL_LABELS = {
  contract: "Termini di Utilizzo Affidya v1.0",
  privacy: "Privacy Policy",
  cookies: "Cookie Policy",
  dpa: "Accordo di Nomina a Responsabile del Trattamento",
};

export const CHECKBOX_TERMS_TEXT =
  "Ho letto e accetto i Termini di Utilizzo Affidya v1.0, la Privacy Policy, la Cookie Policy e l'Accordo di Nomina a Responsabile del Trattamento, ove applicabile.";

export const CHECKBOX_CLAUSES_TEXT =
  "Ai sensi e per gli effetti degli artt. 1341 e 1342 c.c., approvo specificamente le clausole relative a: natura e limiti del servizio, responsabilità degli utenti, divieti di utilizzo, funzionalità IA, integrazioni terze, sospensione del servizio, pagamenti, rinnovo, recesso, conservazione dati, log, proprietà intellettuale, limitazione di responsabilità, manleva, risoluzione, modifiche contrattuali e foro competente.";

export const ACCEPTANCE_FOOTNOTE =
  "L'accettazione viene registrata con data, ora, indirizzo IP, utente, struttura e versione contrattuale ai fini della prova tecnica dell'accettazione.";

export const isLegalAcceptanceComplete = (values) =>
  Boolean(values?.acceptedTerms && values?.acceptedClauses1341);

export const defaultLegalAcceptanceValues = () => ({
  acceptedTerms: false,
  acceptedClauses1341: false,
});
